import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import immutable from 'immutable'

import {LunaLoader} from '../widgets/lunaloader/lunaloader.component'
import {HeaderBlock} from '../widgets/layout/headerblock.component'
import {AccommodationSearchResults} from './accommodationsearchresults.component'
import {AccommodationItem} from './accommodationitem.component'
import {AutoComplete} from '../widgets/autocomplete/autocomplete.component'
import {SearchFail} from '../widgets/searchfail.component'

const ELASTISEARCH_URL = '/api/v1/hotels/autocomplete/'

export class AccommodationsSearch extends React.Component {
    constructor(props) {
        super(props)

        this.state = this.defaultState()
        this._isMounted = false
        this._trimResults = false
        this._curPage = 1
        this._allDone = false

        _.bindAll(this,
            'getResults',
            'activateSearchItem',
            'deActivateSearchItem',
            'onExecuteQuery',
            'onRenderResult',
            'onChoose'
        )
    }

    defaultState() {
        return {
            destID: this.props.leg.getIn(['destination', 'id']),
            results: null,
            loading: true,
            showSearchItem: false,
            selectedSearchItem: null
        }
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.leg.getIn(['destination', 'id']) !== this.state.destID) {
            // Destination changed
            this._trimResults = false
            this._curPage = 1
            this.setState({destID: nextProps.leg.getIn(['destination', 'id']), loading: true, results: null})
        } else if (nextProps && nextProps.results && nextProps.results.length !== this.state.results.length) {
            // Append newer results from second search
            this.setState({results: nextProps.results})
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.destID !== this.state.destID) {
            // Destination changed, search again
            this._trimResults = false
            this._curPage = 1
            this.getResults()
        }
    }

    componentDidMount() {
        this._isMounted = true
        this.getResults()
    }

    componentWillUnmount() {
        this._isMounted = false
    }


    onExecuteQuery(q) {
        return axios.get(ELASTISEARCH_URL, {
            params: {
                query: q
            }
        }).then((response) => response.data)
    }


    onRenderResult(result) {
        return (
            <div className="result-item">
                <div className="result-label">
                    <div className="result-name">{result.name}</div>
                </div>
            </div>
        )
    }

    onChoose(choice) {
        let accom = new immutable.fromJS(choice)
        this.activateSearchItem(accom)
    }


    activateSearchItem(accom) {
        this.setState({showSearchItem: true, selectedSearchItem: accom})
    }

    deActivateSearchItem() {
        this.setState({showSearchItem: false, selectedSearchItem: null})
    }

    getRadius(bounds) {
        let lat1 = bounds.south
        let lon1 = bounds.west
        let lat2 = bounds.north
        let lon2 = bounds.east

        if (!lat1 || !lon1 || !lat2 || !lon2) {
            return '10km'
        }

        var p = 0.017453292519943295    // Math.PI / 180
        var c = Math.cos
        var a = 0.5 - c((lat2 - lat1) * p) / 2 +
          c(lat1 * p) * c(lat2 * p) *
          (1 - c((lon2 - lon1) * p)) / 2

        let diameter = 12742 * Math.asin(Math.sqrt(a))

        // If we're going to be 10km for the radius, let's bump it up a bit
        if (diameter < 20) {
            diameter = 50
        }

        return Math.round(diameter / 2) + 'km'
    }

    getResults() {
        // Need to get the id of the destination out of the leg
        let destID = this.state.destID

        // Need to set self for scope of ajax query
        let self = this

        if (destID !== -1) {
            let exclude = []
            this.props.leg.get('accommodations').map((accommodation) => {
                exclude.push(accommodation.get('id'))
            })

            let destinationItem = this.props.leg.get('destination')
            let boundedRadius = destinationItem.getIn(['opencage', 'bounds']) ? this.getRadius(JSON.parse(destinationItem.getIn(['opencage', 'bounds']))) : '10km'

            axios.get('/api/v1/destinations/info/' + destID + '/near/', {
                params: {
                    type: 'accommodation',
                    skip: exclude.join(),
                    limit: 9,
                    offset: (self._curPage - 1) * 9,
                    distance: boundedRadius
                }
            }).then(function(response) {
                if (response.data) {
                    let data = response.data.results
                    if (response.data.next) {
                        self._trimResults = true
                        self._curPage += 1
                    } else {
                        self._trimResults = false
                        self._allDone = true
                    }
                    if (self._isMounted) {
                        self.setState(function(state) {
                            if (state.results) {
                                return {
                                    results: state.results.concat(data),
                                    loading: false
                                }
                            } else {
                                return {
                                    results: data,
                                    loading: false
                                }
                            }
                        })
                    }
                }
            })
        } else {
            // Didn't have an id to search – show error?
            if (this._isMounted) {
                this.setState({
                    results: [],
                    loading: false
                })
            }
        }
    }

    render() {
        let results = null
        let allDone = null

        if (this.state.loading) {
            results = <LunaLoader style="basic"/>
        } else if (this.state.results.length === 0) {
            results = <SearchFail {...this.props} type="accommodation"/>
        } else {
            results = <AccommodationSearchResults
                  {...this.props}
                  showMe={true}
                  activateSearchItem={this.activateSearchItem}
                  accommodations={this.state.results}/>
            allDone = this._allDone ? <SearchFail {...this.props} format="endoflist" type="accommodation"/> : ''
        }

        // TODO: Figure out how pagination works with the two different calls to decide if we have more to show
        // TODO: Set to loader after click
        let showMore = this._trimResults ? <div className="btn btn-plain" onClick={() => { this.getResults() }}>Show More</div> : ''
        let header = 'More places to stay in ' + this.props.leg.getIn(['destination', 'title'])


        if (this.state.showSearchItem) {
            return <AccommodationItem {...this.props} goBack={ this.deActivateSearchItem } activeAccommodation={ this.state.selectedSearchItem }/>
        } else {
            return (
                <div className="view-area">
                    <div className="view-left-col">
                        <a onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.OVERVIEW)} className="btn">Go Back</a>
                    </div>
                    <div className="view-center">
                        <HeaderBlock header={header} body="Explore the list below or add your own."/>
                        <AutoComplete
                      type='accommodation'
                      onExecuteQuery={this.onExecuteQuery}
                      onRenderResult={this.onRenderResult}
                      onChoose={this.onChoose}
                      placeholder='Search'/>
                        {results}
                        {showMore}
                        {allDone}
                    </div>
                    <div className="view-right-col">
                        <a className="btn btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.ENTRY)}>
                            <i className="icon-circle_add"/><span>ADD MY OWN</span>
                        </a>
                    </div>
                </div>
            )
        }
    }
}
